var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.ModuleContainer,
    _vm._b(
      {
        scopedSlots: _vm._u([
          {
            key: "draggable",
            fn: function (props) {
              return [
                _setup.layer_map_component
                  ? _c(
                      _setup.DraggableSidebar,
                      _vm._b(
                        {
                          attrs: { right: "", show: _setup.show },
                          on: {
                            "update:show": function ($event) {
                              _setup.show = $event
                            },
                            close: _setup.onClose,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "layer-control__title" },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _setup.trans(
                                                "map.style-control.title"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        "DraggableSidebar",
                        props,
                        false
                      ),
                      [
                        _c(
                          "div",
                          { staticClass: "style-control" },
                          [
                            _c(_setup.layer_map_component, {
                              tag: "component",
                              attrs: {
                                trans: _setup.trans,
                                mapId: _setup.c_mapId,
                              },
                              on: { "update-style": _setup.onUpdateStyle },
                              model: {
                                value: _setup.layer,
                                callback: function ($$v) {
                                  _setup.layer = $$v
                                },
                                expression: "layer",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      },
      "ModuleContainer",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }